import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';
import { OverlayTrigger, PopOver, Switch, Icon, Select } from '@tencent/spaui';
import { RPCFactory } from '../../../../utils/RequestUtil';
import { judgeIsFromTMC } from '../../../../utils';
import { SmsNotification } from '../../../../consts/LeadsDistriSettings';
import { isSubAccount } from '../../../../consts/multiAccountConfig';

const mapStateToProps = (state) => ({ ...state.leadsManage });

class SmsTab extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      notificationSettings: SmsNotification.SMS_NOTIFICATION_OFF.getId(),
      notificationToUser: SmsNotification.SMS_NOTIFICATION_OFF.getId(),
      flashletterNotification: SmsNotification.SMS_NOTIFICATION_OFF.getId(),
      companyNames: [],
      activeCompanyName: 'XX',
      leadsSmsSignature: '' // 用户留资短信触达短信签名，如 腾讯，若未配置，则该值为空
    };

    this.handleSwitchChange = this.handleSwitchChange.bind(this);
    this.handleUserSwitchChange = this.handleUserSwitchChange.bind(this);
    this.handleShanxinSwitchChange = this.handleShanxinSwitchChange.bind(this);
  }

  componentDidMount() {
    this.getNotification();
    this.getShanxinCompanyNames();
  }

  getShanxinCompanyNames = () => {
    RPCFactory.accountSettings.getShanxinCompanyNames().done((data) => {
      this.setState(
        {
          companyNames: data,
        },
        this.getActiveCompanyName,
      );
    });
  };
  setShanxinCompanyName = (companyName) => {
    RPCFactory.accountSettings
      .setShanxinCompanyName(companyName)
      .done(() => {})
      .fail((ret, msg) => {
        alert(msg);
      });
  };
  getSwitchString = (value) => {
    return value
      ? SmsNotification.SMS_NOTIFICATION_ON.getId()
      : SmsNotification.SMS_NOTIFICATION_OFF.getId();
  }
  getNotification() {
    RPCFactory.accountSettings.getNotification().done((data) => {
      this.setState({
        notificationSettings: data.notificationSettings,
        notificationToUser: data.leadsSmsNotifyToUser,
        flashletterNotification: data.flashletterNotification,
        leadsSmsSignature: data.leadsSmsSignature,
      });
    });
  }
  setShanxinNotification(value) {
    const str = this.getSwitchString(value);
    RPCFactory.accountSettings
      .setFlashletterNotification(str)
      .done((data) => {
        this.setState({
          flashletterNotification: str,
        });
      })
      .fail((ret, msg) => {
        alert(msg);
      });
  }
  setNotification(value) {
    const str = this.getSwitchString(value);
    RPCFactory.accountSettings
      .setNotification(str)
      .done((data) => {
        this.setState({
          notificationSettings: str,
        });
      })
      .fail((ret, msg) => {
        alert(msg);
      });
  }

  setUserNotification(value) {
    const str = this.getSwitchString(value);
    RPCFactory.accountSettings
      .setUserNotification(str)
      .done((data) => {
        this.setState({
          notificationToUser: str,
        });
      })
      .fail((ret, msg) => {
        alert(msg);
      });
  }

  handleSwitchChange(event, value) {
    this.setNotification(value);
  }

  handleShanxinSwitchChange(event, value) {
    this.setShanxinNotification(value);
  }

  handleUserSwitchChange(event, value) {
    this.setUserNotification(value);
  }

  getActiveCompanyName = () => {
    const activeCompanyIndex = _.findIndex(this.state.companyNames, 'set');
    const activeCompanyName = activeCompanyIndex > -1 ? this.state.companyNames[activeCompanyIndex].name : 'XX';
    this.setState({ activeCompanyName });
  };
  handleChangeName = (event, companyName) => {
    this.setState({ activeCompanyName: companyName });
    this.setShanxinCompanyName(companyName);
  };

  goToMultiAccount = () => {
    if(judgeIsFromTMC()) {
      // 跳转子账户列表
      top.postMessage({ type: 'goToMultiAccount', }, '*');
    } else {
      window.location.hash = '#/system/multiAccount';
      location.reload();
    }
  };

  render() {
    const popover = (
      <PopOver>
        <span style={{ 'word-break': 'break-all' }}>
          【腾讯广告】您有一条新线索，请及时前往线索管理平台小程序或者PC端跟进线索。
        </span>
      </PopOver>
    );
    // 短信提示文案 by fightingliu
    const title = this.state.leadsSmsSignature || '广告主短信签名';
    const smsText =
      window.pageProps.industryCode1 == 21474836541 && window.pageProps.industryCode2 == 21474842605
        ? `【${title}】您已成功登记，商家维修人员会与您联系。如有售后问题可点击 xxx（售后链接），拨打页面中的电话联系工作人员进行处理。如就广告问题需协助处理，可通过ads_service@tencent.com反馈，谢谢！`
        : `【${title}】尊敬的用户，您好，您已成功提交报名信息，客服人员将会在24小时内与您联系，感谢您对我们的信赖和支持，点击xxxx（用户填写信息的报名链接）了解详情。`;

    const companyData = this.state.companyNames.map((item) => ({ label: item.name, value: item.name }));
    // const activeCompanyName = this.getActiveCompanyName();

    const notificationSettingsChecked = this.state.notificationSettings == SmsNotification.SMS_NOTIFICATION_ON.getId();
    const notificationToUserChecked = this.state.notificationToUser == SmsNotification.SMS_NOTIFICATION_ON.getId();
    return (
      <div className="secs">
        <div className="sec">
          {(!judgeIsFromTMC() || (judgeIsFromTMC() && notificationSettingsChecked)) &&
            <div className="card">
              <div className="panel message-set">
                <div className="panel-heading sms">
                  <p className="panel-title">
                    线索分配短信通知设置
                    <Switch
                      checked={this.state.notificationSettings == SmsNotification.SMS_NOTIFICATION_ON.getId()}
                      onChange={this.handleSwitchChange}
                    />
                  </p>
                  <div className="text">
                    开启该功能后，当线索分配给员工时，员工将收到短信通知；对14天以前的线索进行分配时将不再触发短信通知。
                    <OverlayTrigger trigger="hover" placement="top" overlay={popover} hideDelayTime={1000}>
                      <a href="javascript:void(0)">短信示例</a>
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
            </div>
          }
          <div className="card shanxin">
            <i className="connection-up" />
            {(!judgeIsFromTMC() || (judgeIsFromTMC() && notificationToUserChecked)) &&
              <div className="panel message-set margin-bottom">
                <div className="panel-heading">
                  <p className="panel-title">
                    用户留资短信触达设置
                    <Switch
                      checked={this.state.notificationToUser == SmsNotification.SMS_NOTIFICATION_ON.getId()}
                      onChange={this.handleUserSwitchChange}
                    />
                  </p>
                  <div className="duanxin-description">
                    开启该功能后，用户填写并提交信息后，系统将自动给用户发送短信提醒（可能存在5-10分钟延迟），同一广告重复留资只发一次短信。
                  </div>

                  <span className="shanxin-title">短信文案</span>
                  <span>{smsText}</span>
                </div>
              </div>
            }
            <div className="panel message-set">
              <div className="panel-heading">
                <p className="panel-title">
                  用户接听电话闪信提示
                  <Switch
                    checked={this.state.flashletterNotification == SmsNotification.SMS_NOTIFICATION_ON.getId()}
                    onChange={this.handleShanxinSwitchChange}
                    disabled={isSubAccount()}
                  />
                </p>
                <div className="shanxin-part">
                  <p className="shanxin-description">
                    闪信为升级版短信，无需点击直接展开，阅读率100%。电销人员使用线索管理小程序给用户拨打电话时，线索管理平台免费给用户发送闪信，告知您的公司姓名及来电号码，提升企业形象的同时，大幅提升接通率。
                  </p>
                  <div className="shanxin-text">
                    <span className="shanxin-title">闪信文案</span>
                    <span className="shanxin-highlight">
                      {`【腾讯广告】您好，${this.state.activeCompanyName}已收到您提交的信息，工作人员正在与您联系，请您放心接听。`}
                    </span>
                    {/* <span className="shanxin-content">
                      （公司名是您在广告平台开户时填写的名称）
                    </span> */}
                    <div className="change-name">
                      <span className="change-name-text">修改公司名称</span>
                      <Select
                        data={companyData}
                        value={this.state.activeCompanyName}
                        onChange={this.handleChangeName}
                        searchEmptyTip={companyData.length > 0 ? '没有相关搜索' : null}
                        disabled={isSubAccount()}
                      />
                    </div>
                  </div>
                  <div className="subaccount-tip">
                    <span>注：主账号设置的短信触达和闪信规则会同时生效在子账号中，开启按钮前请确认是否绑定子账号并检查</span>
                    <a
                      href="javascript:void(0)"
                      onClick={this.goToMultiAccount}
                    >
                      子账户列表
                    </a>
                    <span>，确保当前设置的公司名称可以应用于所有子账号。</span>
                  </div>
                  <div className="shanxin-example">
                    <span className="shanxin-title">闪信示例</span>
                    <Icon name="info-filled" color="#296BEF" style={{ marginBottom: '-3px', marginRight: '3px' }} />
                    <span className="shanxin-content">展示效果因手机系统和型号不同有所差异，示例仅供参考</span>
                  </div>
                  <div className="shanxin-phone-example"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const smsTab = withRouter(connect(mapStateToProps)(SmsTab));
export default smsTab;
